import React from 'react'
import Gallery from '../Component/Gallery'

const Gallerry = () => {
  return (
    <div>
      <Gallery/>
    </div>
  )
}

export default Gallerry
